import { useTranslation } from 'react-i18next';

import { useCreateBrand } from '~/api/user';
import { toast } from '~/utils/toast';

import type { CreateBrandFormType, CreateBrandModalProps as Props } from './types';

import { CreateEditBrandModal } from './CreateEditBrandModal';
import { convertFileToBase64String } from './utils';

export const CreateBrandModal = ({ onClose }: Props) => {
  const mutation = useCreateBrand();

  const { t } = useTranslation(['common', 'settings']);

  const onSubmit = async (data: CreateBrandFormType) => {
    return mutation.mutate(
      {
        companyName: data.companyName,
        email: data.email,
        color: data.color,
        logo: data.logo ? await convertFileToBase64String(data.logo) : '',
      },
      {
        onSuccess: () => {
          toast.success({ description: t('settings:alerts.brands.successCreated') });
          onClose();
        },
        onError: () => {
          toast.danger({ description: t('common:error') });
        },
      },
    );
  };

  return <CreateEditBrandModal brand={null} isLoading={mutation.isPending} onClose={onClose} onSubmit={onSubmit} />;
};
